// import axios from 'axios'

export async function uploadImageToImgur(image) {
    let apiUrl = 'https://api.imgur.com/3/image';
    let apiKey = '54b4e833784b011';
    let settings = {
        async: false,
        crossDomain: true,
        processData: false,
        contentType: false,
        datatype: "json",
        type: 'POST',
        url: apiUrl,
        headers: {
            Authorization: 'Client-ID ' + apiKey,
            Accept: 'application/json'
        },
        mimeType: 'multipart/form-data'
    };

    let formData = new FormData();
    formData.append("image", image);
    settings.data = formData;

    return await fetch(apiUrl, {
        method: 'POST',
        headers: {
            Authorization: 'Client-ID ' + apiKey,
            Accept: 'application/json'
        },
        body: formData
    })

// return axios.post(apiUrl,formData, {
//     headers: {
//         Authorization: 'Client-ID ' + apiKey,
//         Accept: 'application/json'
//     }
// })

// fetch(apiUrl, {
//     method: 'POST',
//    ,
//     body: formData
// }).then(res => res.json().then((json) => {
//         if (res.ok) {
//             return json
//         } else {
//             this.setState({responseMessage: 'Error unloading photo try adding manually', CreatedOffer: true});
//         }
//     })
// ).then(json => console.log(json)).catch(er => {
//     this.setState({responseMessage: 'Error unloading photo try adding manually', CreatedOffer: true});
//
// }).finally(() => {
//     this.setState({addOffer: false, responseMessage: '', CreatedOffer: false});
// })

}
